
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { clearLocalStorageExceptOne } from '../../../common/Utilities';
import { ServerAPI } from '../../../common/ServerAPI';
import { AuthenticationContext } from '../../../App';
import { toast } from 'react-toastify';
const LoanSuccessModal = ({ open, close, message }) => {
    const { authData, } = useContext(
        AuthenticationContext
    );

    const permission = authData?.permissions
        ?.filter((it) => it?.name === "loan")
        ?.map((it) =>
            it?.submodules
        ).flat()?.filter((itx) => itx?.name === "loan-application-cases")

    const navigate = useNavigate();
    const [loanDetails, setLoanDetails] = useState({});

    const updateApplication = async (updateLoanDetails) => {
        try {
            const response = await ServerAPI.completeLoanApplication(updateLoanDetails);
            if (response.data) {
                navigate('/case-list', {
                    state: {
                        ...permission[0],
                    },
                });
                clearLocalStorageExceptOne("dealerModuleToken");
            }
        } catch (error) {
            toast.error("Sorry application not submitted..!")
        }
    }
    const modalHandler = () => {
        let finalData = {};
        if (message == 'completed') {
            finalData['is_completed'] = 1;
            finalData["loanamount"] = loanDetails.loanamount;
            finalData["tenure"] = loanDetails.tenure;
            finalData["parfvalue"] = loanDetails.parfvalue;
            finalData["loanfor"] = localStorage.getItem('loantype');
            finalData["category"] = loanDetails.category;
            finalData["loanType"] = loanDetails.loanType;
            updateApplication(finalData);
        } else {
            navigate('/loan-application');
            clearLocalStorageExceptOne("dealerModuleToken");
        }
    }

    const getLoanDetails = async () => {
        let applicationId = localStorage.getItem('applicationno');
        if (applicationId) {
            const response = await ServerAPI.getApplication();
            if (response) {
                setLoanDetails(response.data);
            }
        }
    }

    useEffect(() => {
        getLoanDetails();
    }, [])
    return (
        open == true &&
        <div
            className="fixed inset-0 z-50 flex items-center justify-center backdrop-filter backdrop-blur-sm"
            style={{ background: 'rgba(0, 0, 0, 0.5)' }}
        >
            <Modal
                centered
                open={open}
                footer={false}
                onCancel={close}
            >
                <div className='flex m-[0_auto] justify-center'>
                    <img src='/images/final_tick.png' height={'auto'} />
                </div>
                <div className='m-[0_auto] text-center'>
                    {message == 'completed' ?
                        <Fragment>
                            <p className='text-[20px] font-[700]'>Loan Application Case is ready</p>
                            <p className='text-[12px] font-[400] mt-1'>All document(s) & signature(s) have been received.</p>
                            <p className='text-[12px] font-[400] mt-1'>Dealers will inform the applicant of any updates on their loan application progress</p>
                        </Fragment>
                        :
                        <Fragment>
                            <p className='text-[20px] font-[700]'>Loan Application Case Saved as Draft</p>
                            <p className='text-[12px] font-[400] mt-1'>You may Submit your application once you are ready.</p>
                        </Fragment>
                    }
                    <Button onClick={() => {
                        modalHandler();
                    }} className='text-white mt-5' type='primary'>Close</Button>
                </div>
            </Modal>
        </div>
    );
};
export default LoanSuccessModal;